module.exports = __webpack_public_path__ + "img/logo-w.74a3e844.png";